/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AccountDetails } from './AccountDetails';
import {
    AccountDetailsFromJSON,
    AccountDetailsFromJSONTyped,
    AccountDetailsToJSON,
} from './AccountDetails';

/**
 * 
 * @export
 * @interface AccountDetailsOutput
 */
export interface AccountDetailsOutput {
    /**
     * 
     * @type {AccountDetails}
     * @memberof AccountDetailsOutput
     */
    account?: AccountDetails;
    /**
     * 
     * @type {Error}
     * @memberof AccountDetailsOutput
     */
    error?: Error;
}

/**
 * Check if a given object implements the AccountDetailsOutput interface.
 */
export function instanceOfAccountDetailsOutput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AccountDetailsOutputFromJSON(json: any): AccountDetailsOutput {
    return AccountDetailsOutputFromJSONTyped(json, false);
}

export function AccountDetailsOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountDetailsOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'account': !exists(json, 'account') ? undefined : AccountDetailsFromJSON(json['account']),
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function AccountDetailsOutputToJSON(value?: AccountDetailsOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'account': AccountDetailsToJSON(value.account),
        'error': value.error,
    };
}

